import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch,
  faBookOpen,
  faCode,
  faRocket,
} from '@fortawesome/free-solid-svg-icons';
import BackgroundImage from '../images/Background-process.png';
import './style.css';

const steps = [
  {
    title: 'Discovery',
    icon: faSearch,
    description:
      'We research your business, market, and goals to identify the best growth opportunities.',
  },
  {
    title: 'Strategy',
    icon: faBookOpen,
    description:
      'We craft a tailored plan that aligns with your objectives and maximizes ROI.',
  },
  {
    title: 'Development',
    icon: faCode,
    description:
      'We build the tech and experiences needed — fast, scalable, and effective.',
  },
  {
    title: 'Launch',
    icon: faRocket,
    description:
      'We go live with precision, monitoring everything to ensure results from day one.',
  },
];

function ProcessSection() {
  // Responsive detection for mobile
  const [isMobile, setIsMobile] = React.useState(false);
  React.useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return (
    <section id="process" className="process-section">
      <Container>
        <div className="text-center mb-5">
          <h2 className="fw-bold mb-3 process-title">
            Our Process
          </h2>
          <p className="lead process-lead">
            From discovery to launch, we cover the entire journey
          </p>
        </div>

        <Row
          className="process-background"
          style={{
            backgroundImage: isMobile ? 'none' : `url(${BackgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          {steps.map((step, index) => (
            <Col
              key={index}
              xs="12"
              md="3"
              className="mb-4 mb-md-0"
              style={{
                marginTop: !isMobile && index % 2 === 1 ? '80px' : '0px',
              }}
            >
              <div className="step-card">
                <div className="icon-circle">
                  <FontAwesomeIcon icon={step.icon} />
                </div>
                <h5 className="fw-bold mb-2 step-title">
                  {step.title}
                </h5>
                <p className="step-description">
                  {step.description}
                </p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default ProcessSection;
